import { RefObject } from 'react';
import { clsx } from '../functions'
import { inputOnKeyUp } from "../functions.ts";
import './measure.css'
import { useStore } from '../state/state.ts';

export default function Measure(props:{measure_ref: RefObject<HTMLButtonElement>, id: String, label: string, now?: string, future?: string, onClick: () => void}) {   
  const selected_menu_item = useStore((state) => state.selected_menu_item);
  const future = props.future && props.future.trim();
  const selected = selected_menu_item == props.id;

  return (
     <button 
        ref={props.measure_ref}
        className={'measure' + (selected ? ' measure--selected' : '')}
        tabIndex={0} 
        aria-label={props.label}
        aria-description={
          `Wert aktuell: ${props.now || "nicht definiert"}, Wert nach Sanierung: ${props.future || "nicht definiert"}`
        }
        onClick={props.onClick}
        onKeyUp={(event)=>inputOnKeyUp(event, ()=>{
          props.onClick();
          // setTimeout(() => {
          //   document.querySelector(".modal [tabindex]").focus();
          // }, 100); 
        })}
      >
      <div aria-hidden className='measure__label'>{props.label}</div>
      {(props.now || props.future) && <div aria-hidden className='measure__infos'>
        <div aria-hidden className={clsx('measure__info-now', !future && 'measure__info-now--single')}>{props.now ? props.now : "unsaniert"}</div>
        {
          future && <>
            <div aria-hidden className='measure__info-triangle'></div>
            <div aria-hidden className='measure__info-future'>{props.future}</div>
          </>   
        }
      </div>}
     </button>
  )
}